import { createAxiosClient } from "@ntg/component-library/utilities";

export const getRouteHeaderExistsD365 = async (
    routeId: string,
    dataAreaId: string,
): Promise<boolean> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<boolean>(
        `/RouteHeader/GetRouteHeaderExistsD365`,
        { keys: { routeId, dataAreaId } },
    );
    return response.data;
};
